<div class="mt-2 passengers-total-container">
  <div class="passenger-total-title">
    {{ 'SHOPPING_CART.TOTAL' | translate }}
  </div>
  <div class="d-flex flex-column border passenger-total-table">
    <ng-container *ngFor="let passenger of passengerExtrasSummary; let index">
      <div>
        <div class="border-bottom">
          <div class="p-3 d-flex">
            <strong class="bold"
              >{{ passenger?.gender === genderEnum.Male ? ('GENDER.MALE' | translate) : ('GENDER.FEMALE' | translate) }}
              {{ passenger?.name }}</strong
            >
            <div class="ml-2 text-muted">{{ passenger?.dateOfBirth | formatDate }}</div>
            <strong class="ml-auto">€ {{ passenger?.displayPassengerPrice | formatDecimals : culture }}</strong>
          </div>
        </div>
      </div>
    </ng-container>
    <div class="p-3 d-flex justify-content-end">
      <div class="mr-2">{{ 'SHOPPING_CART.TOTAL' | translate }}</div>
      <strong class="">€ {{ totalPrice | formatDecimals : culture }}</strong>
    </div>
  </div>
</div>
